/**
 * @generated SignedSource<<537ac0ed25e03e9ae856801b5cf61b82>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespStorytellingModule_item$data = {
  readonly storyTellingModule: {
    readonly tabs: ReadonlyArray<{
      readonly tabTitle: string;
      readonly " $fragmentSpreads": FragmentRefs<"PdpRespStorytellingTab_storyTellingTab">;
    } | null> | null;
  } | null;
  readonly seller: {
    readonly isAccessible: boolean | null;
  } | null;
  readonly " $fragmentType": "PdpRespStorytellingModule_item";
};
export type PdpRespStorytellingModule_item$key = {
  readonly " $data"?: PdpRespStorytellingModule_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespStorytellingModule_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespStorytellingModule_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "StoryTellingModule",
      "kind": "LinkedField",
      "name": "storyTellingModule",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "StoryTellingTab",
          "kind": "LinkedField",
          "name": "tabs",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "tabTitle",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpRespStorytellingTab_storyTellingTab"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Seller",
      "kind": "LinkedField",
      "name": "seller",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isAccessible",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "d7f18ba63fd62da964ec6484e1e2010a";

export default node;
